import clsx from 'clsx';
import React from "react";
import { useTranslation } from "react-i18next";

type FooterButtonsProps = {
  setShowAddUserModal: (show: boolean) => void;
  handleResetForm: () => void;
  submitNewUser: () => void;
  disabledButton: boolean;
  isLoading?: boolean;
};

export const FooterButtons = ({
  setShowAddUserModal,
  handleResetForm,
  submitNewUser,
  disabledButton,
  isLoading
}: FooterButtonsProps) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <button
        data-testid="btnCancelSubmitNewUser"
        className="button button--secondary"
        onClick={() => {
          setShowAddUserModal(false);
          handleResetForm();
        }}
      >
        {t("userManagementPage.cancel_btn")}
        <i className="icon icon-close"></i>
      </button>
      <button
        className={clsx("button button--primary", isLoading && "btn--loading")}
        data-testid="btnSubmitNewUser"
        onClick={submitNewUser}
        disabled={disabledButton}
      >
        {t("userManagementPage.create_btn")}
        <i className="icon icon-check"></i>
      </button>
    </React.Fragment>
  );
};
